import withAPIAction from 'utils/withAPIAction'
import { getDataListAction, saveDataAction } from './actions'
import { GetDataListReq, ConfigVendorERCDetailReq } from './types'
import { verifyReq } from 'utils/verify'

export const onGetConfigVendorList = (token: string, data: GetDataListReq) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<GetDataListReq>({
    method: 'POST',
    path: 'GetERCVendorConfigList',
    data,
    token: `Bearer ${token}`,
  })(getDataListAction)
}

export const onSaveVendorERC = (
  token: string,
  data: ConfigVendorERCDetailReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<ConfigVendorERCDetailReq>({
    method: 'POST',
    path: 'SaveERCVendor',
    data,
    token: `Bearer ${token}`,
  })(saveDataAction)
}
